import type React from 'react';

type ToastType = 'success' | 'error' | 'custom';

type ShowToastFn = (
  message: string,
  type: ToastType,
  duration?: number,
  customColor?: string,
  customIcon?: React.ReactNode | false
) => void;

class ToastService {
  private showToastFn: ShowToastFn | null = null;

  register(fn: ShowToastFn) {
    this.showToastFn = fn;
  }

  unregister() {
    this.showToastFn = null;
  }

  show(message: string, type: ToastType) {
    if (this.showToastFn) {
      this.showToastFn(message, type);
    }
  }
}

export const toastService = new ToastService();
